<div class="shell">
    <div class="view">
        <router-outlet></router-outlet>
    </div>
    <div class="loading-block" *ngIf="loading">
        <div class="info-block">
            <div class="title">{{ loading }}</div>
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>
